import { type ChangeEvent, useEffect, useState } from 'react';
import { Check as CheckIcon, Edit as EditIcon } from '@material-ui/icons';
import { Checkbox, Grid, IconButton, Typography } from '@material-ui/core';
import { type IAnswer } from 'src/models';
import { type RootState } from 'src/store';
import { TextField } from 'src/components';
import { useSelector } from 'react-redux';
import { userTypes } from 'src/helpers/constants';
import useStyles from './Answer-styles';

interface Props {
	isNew?: boolean;
	answer: IAnswer;
	handleSetName: (name: string) => void;
	handleIsCorrect: (event: ChangeEvent<HTMLInputElement>) => void;
}

function Answer({ answer, handleIsCorrect, handleSetName }: Props) {
	const classes = useStyles();
	const [name, setName] = useState(answer.name);
	const [isEdit, setIsEdit] = useState(Boolean(answer.isNew));
	const user = useSelector((state: RootState) => state.auth.data);

	useEffect(() => {
		setName(answer.name);
	}, [answer.name]);

	function handleSaveName() {
		handleSetName(name || '');
		setIsEdit(!isEdit);
	}

	return (
		<Grid container item xs={12}>
			<Grid className={classes.center} item xs={1}>
				<Checkbox
					checked={answer.isCorrect}
					color={'secondary'}
					disabled={!(user.type === userTypes.ADMIN)}
					onChange={handleIsCorrect}
				/>
			</Grid>

			<Grid className={classes.answer} item xs={10}>
				{isEdit ? (
					<TextField
						multiline
						onChange={(event: ChangeEvent<HTMLInputElement>) => {
							setName(event.target.value);
						}}
						value={name}
					/>
				) : (
					<Typography> {name} </Typography>
				)}
			</Grid>

			{user.type === userTypes.ADMIN && (
				<Grid className={classes.center} item xs={1}>
					{isEdit ? (
						<IconButton onClick={handleSaveName}>
							<CheckIcon />
						</IconButton>
					) : (
						<IconButton
							onClick={() => {
								setIsEdit(!isEdit);
							}}
						>
							<EditIcon />
						</IconButton>
					)}
				</Grid>
			)}
		</Grid>
	);
}

export default Answer;
